let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g985s")).then(() => parcelRequire('l04jD'));